module.exports = __webpack_public_path__ + "img/12.18635314.jpg";